import Component from '@glimmer/component'
import { colors } from '@colors'
import { SeriesBar } from 'teacher-ui-client/components/giraffe/primitives/series-bar'
import { t } from 'ember-intl'
import type { SeriesBarOptions } from 'highcharts'
import type { AssessmentScoresData } from 'teacher-ui-client/utils/student-events/fetchers/assessment-scores'

interface Args {
  data: AssessmentScoresData
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
}

export class DashboardAssessmentScores extends Component<Signature> {
  get scores(): { range: string; student_count: number }[] {
    const desiredOrder = ['80-100', '50-79', '0-49']
    const scores = this.args.data.scores
    return scores.sort((a, b) => desiredOrder.indexOf(a.range) - desiredOrder.indexOf(b.range))
  }

  get chartBars(): SeriesBarOptions[] {
    return [{ data: this.scores.map((s) => s.student_count), type: 'bar' }]
  }

  get categories(): string[] {
    return this.scores.map((s) => `${s.range}%`)
  }

  get colors(): string[] {
    return [colors.msGreen300, colors.yolkyYellow300, colors.watermelonyRed300]
  }

  <template>
    <div class="flex h-full flex-col" ...attributes>
      <div class="mb-6 flex justify-between">
        <div data-test-average-score class="text-dusty-black-500 pr-[5px] pl-0 text-xs">
          {{t "reporting.dashboardSubtitles.assessmentScores.score" score=@data.average_score}}
        </div>
        <div data-test-average-attempts class="text-dusty-black-500 pr-0 pl-[5px] text-right text-xs">
          {{t "reporting.dashboardSubtitles.assessmentScores.attempts" attempts=@data.average_attempts}}
        </div>
      </div>
      <div class="relative grow">
        <div class="absolute inset-0">
          <SeriesBar
            @data={{this.chartBars}}
            @categories={{this.categories}}
            @colors={{this.colors}}
            @colorByPoint={{true}}
            @yAxisLabel={{t "reporting.statBoxes.assessmentScoresTotals.numOfStudents"}}
          />
        </div>
      </div>
    </div>
  </template>
}

export default DashboardAssessmentScores
